// imove-branch: 当前访问路径为/home?host_id=**

export default async function(ctx) {
    const { pathname = '',query } = ctx.payload;
    const IsHome = '/home'.startsWith(pathname);
    const hostId=query?.host_id||'';
    if (IsHome && hostId) {
        return true;
    }
   return false;
}